import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

import { getUserInfoApi } from '@/api/userApi'
import { useUserStore } from '@/store/userStore'
import qbeeHappyTransparent from '@/assets/images/qbee-character/qbee-happy-transparent.png'

export default function TestSignupCheckPage() {
  const { setUserInfo } = useUserStore()
  const [searchParams] = useSearchParams()
  const user_id = searchParams.get('user_id')
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const handleSignupCheck = async () => {
      try {
        if (!user_id) {
          throw new Error('사용자 ID가 없습니다.')
        }

        const userInfoResponse = await getUserInfoApi(Number(user_id))
        setUserInfo(userInfoResponse.data)

        setTimeout(() => {
          navigate('/')
        }, 1000)
      } catch (error: any) {
        console.error('getUserInfoApi error', error)

        // 에러 메시지 설정
        let errorMessage = '로그인 처리 중 오류가 발생했습니다.'

        if (error.response) {
          const status = error.response.status
          if (status === 404) {
            errorMessage = '사용자 정보를 찾을 수 없습니다.'
          } else if (status === 401) {
            errorMessage = '인증에 실패했습니다.'
          } else {
            errorMessage = '서버 오류가 발생했습니다.'
          }
        } else if (error.message) {
          errorMessage = error.message
        }

        setError(errorMessage)

        // 3초 후 테스트 로그인 페이지로 이동
        setTimeout(() => {
          navigate('/auth/test-login')
        }, 3000)
      }
    }
    handleSignupCheck()
  }, [user_id, setUserInfo, navigate])

  return (
    <div className='min-h-screen bg-gradient-to-r from-amber-400 to-yellow-300 flex items-center justify-center relative overflow-hidden'>
      {/* 배경 장식 요소들 */}
      <div className='absolute top-20 left-10 w-16 h-16 bg-white/20 rounded-full animate-pulse'></div>
      <div className='absolute top-40 right-16 w-12 h-12 bg-white/15 rounded-full animate-pulse delay-300'></div>
      <div className='absolute bottom-32 left-20 w-20 h-20 bg-white/10 rounded-full animate-pulse delay-500'></div>
      <div className='absolute bottom-20 right-10 w-14 h-14 bg-white/20 rounded-full animate-pulse delay-700'></div>

      {/* 메인 콘텐츠 */}
      <div className='text-center z-10 px-8'>
        <div className='bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30'>
          <div className='flex justify-center mb-6'>
            <div className='relative'>
              {error ? (
                <div className='text-4xl animate-none'>😵</div>
              ) : (
                <img src={qbeeHappyTransparent} alt='큐비 캐릭터' className='w-16 h-16 animate-bounce' />
              )}
              {!error && <div className='absolute -top-2 -right-2 text-2xl animate-pulse delay-300'>✨</div>}
            </div>
          </div>

          {error ? (
            <>
              <h1 className='text-red-700 text-xl font-bold leading-relaxed mb-2'>로그인 실패!</h1>
              <p className='text-red-600 text-base mb-4'>{error}</p>
              <p className='text-amber-800 text-sm'>잠시 후 테스트 로그인 페이지로 이동할게!</p>
            </>
          ) : (
            <>
              <h1 className='text-amber-900 text-xl font-bold leading-relaxed mb-2'>로그인 처리 중이야!</h1>
              <p className='text-amber-800 text-base'>잠시만 기다려줘!</p>

              {/* 로딩 인디케이터 */}
              <div className='mt-6 flex justify-center'>
                <div className='w-8 h-8 border-3 border-amber-200 border-t-amber-600 rounded-full animate-spin'></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
